import {
  Box,
  Container,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import { Link } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useState } from "react";
import { QUERY_LISTING_COLUMNS } from "./raisequeryconstants";

import AddQueryModal from "./AddQueryModal";
import NoDataComponent from "../../common/RecordNotFound";
import SmartSearch from "../../common/SmartSearch";
import { searchVendorQuery } from "../../services/queryServices";
import { useLoading } from "../../common/LoadingContext";
import { useNotificationContext } from "../../common/NotificationContext";
import { convertToUpperCase, isValidDate } from "../../utils/jsUtils";

const QueryList = ({
  setSearchedRows,
  searchedRows,
  queryTypeList,
  totalNoOfRecords,
  getQueryList,
}) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [maxPage, setMaxPage] = useState(0);
  const { setLoading } = useLoading();
  const [isSearchMode, setIsSearchMode] = useState(false);
  const { showNotification } = useNotificationContext();
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const handleChangePage = async (event, newPage) => {
    if (newPage > page && newPage > maxPage) {
      setMaxPage(newPage);
      !isSearchMode && (await getQueryList(newPage, rowsPerPage, true));
    }
    setPage(newPage);
  };

  const handleChangeRowsPerPage = async (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    !isSearchMode && (await getQueryList(0, parseInt(event.target.value, 10)));
    setMaxPage(0);
  };
  const selectSearchId = (key) => {
    switch (key) {
      case "Query Id":
        return "QUERY_ID";
      case "Query Type":
        return "QUERY_TYPE";
      case "Query Sub Type":
        return "QUERY_SUB_TYPE";
      case "Date":
        return "CREATED_DATE";

      default:
        break;
    }
  };
  const checkData = (data) => {
    if (data.searchWith === "Date") {
      return isValidDate(data.searchValue);
    } else {
      return true;
    }
  };
  function convertDate(date) {
    // eslint-disable-next-line no-useless-escape
    const parts = date.split(/[\.\-\/]/).map((p) => parseInt(p, 10));
    return `${parts[2]}-${parts[1]}-${parts[0]}`;
  }
  return (
    <>
      <Container maxWidth="xl" sx={{ mt: 8, px: 1 }} disableGutters>
        <Grid container spacing={1} sx={{ pl: 3, pr: 3 }} display="flex">
          <Grid item xs={12} md={4} textAlign="left" alignSelf={"center"}>
            <div className="pageHeader">
              Query List{" "}
              {searchedRows?.length > 0 && `(${searchedRows?.length})`}
            </div>
          </Grid>

          <Grid item xs={12} md={8} textAlign={"right"}>
            <SmartSearch
              options={[
                { id: "Query Id", label: "Search By Query Id" },
                { id: "Query Sub Type", label: "Search By Query Sub Type" },
                { id: "Query Type", label: "Search By Query Type" },
                { id: "Date", label: "Search By Date" },
              ]}
              onActionClick={async (searchObject) => {
                if (searchObject?.searchValue && checkData(searchObject)) {
                  try {
                    setLoading(true);

                    const requestBody = {
                      searchValue:
                        searchObject?.searchWith === "Date"
                          ? convertDate(searchObject?.searchValue)
                          : searchObject?.searchValue,
                      searchFlag: selectSearchId(searchObject?.searchWith),
                    };
                    let searchResultResponse = await searchVendorQuery(
                      baseUrl,
                      requestBody
                    );

                    if (searchResultResponse?.messageCode === 6) {
                      setSearchedRows(searchResultResponse?.queryDetailParam);
                      setIsSearchMode(true);
                      setPage(0);
                    } else {
                      showNotification(
                        "Not Found",
                        "No Record Found With Search Parameters"
                      );
                    }
                  } catch (err) {
                    showNotification(
                      "Error",
                      err?.message ?? "Failed To Search Value"
                    );
                  } finally {
                    setLoading(false);
                  }
                } else if (searchObject?.searchWith === "Date") {
                  showNotification("Error", "Enter a Valid date");
                } else {
                  showNotification("Error", "Something went wrong");
                }
              }}
              isSearchMode={isSearchMode}
              onCancelClick={async () => {
                setIsSearchMode(false);
                await getQueryList(0, 10);
                setPage(0);
                setMaxPage(0);
              }}
            />
            <AddQueryModal
              queryTypeList={queryTypeList}
              onSaveAction={async () => {
                await getQueryList(0, 10);
                setPage(0);
                setMaxPage(0);
              }}
            />
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item xs={12} mb={5} sx={{ pl: 3, pr: 3, mt: 2 }}>
            {searchedRows?.length > 0 ? (
              <Paper elevation={3} variant="elevation">
                <TableContainer sx={{ maxHeight: 720 }} className="tableScroll">
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <TableRow key={"1"}>
                        {QUERY_LISTING_COLUMNS.map((column) => (
                          <TableCell
                            size="small"
                            variant="head"
                            key={column.id}
                            className="tableHeader"
                            sx={{ pt: 1.5, pb: 1.5, fontSize: "13px" }}
                          >
                            {column.label}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>

                    <TableBody sx={{ mt: 2 }}>
                      {searchedRows
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row, index) => {
                          return (
                            <TableRow hover tabIndex={-1} key={index}>
                              <TableCell
                                size="small"
                                sx={{ pt: 1.5, pb: 1.5, fontSize: "12px" }}
                                key={"queryId"}
                              >
                                {row["queryId"]}
                              </TableCell>
                              <TableCell
                                size="small"
                                sx={{ pt: 1.5, pb: 1.5, fontSize: "12px" }}
                                key={"type"}
                              >
                                {row["queryType"] !== null &&
                                row["queryType"]?.type !== null
                                  ? row["queryType"]?.type
                                  : "NA"}
                              </TableCell>
                              <TableCell
                                size="small"
                                sx={{ pt: 1.5, pb: 1.5, fontSize: "12px" }}
                                key={"subType"}
                              >
                                {row["querySubType"] !== null &&
                                row["querySubType"]?.subType !== null
                                  ? row["querySubType"]?.subType
                                  : "NA"}
                              </TableCell>

                              <TableCell
                                size="small"
                                sx={{ pt: 1.5, pb: 1.5, fontSize: "12px" }}
                                key={"commentBox"}
                              >
                                {row["comment"]}
                              </TableCell>
                              <TableCell
                                size="small"
                                sx={{
                                  pt: 1.5,
                                  pb: 1.5,
                                  fontSize: "12px",
                                  color:
                                    convertToUpperCase(row["statusContent"]) ===
                                    "ACTIVE"
                                      ? "green"
                                      : "red",
                                }}
                                key={"status"}
                              >
                                {convertToUpperCase(row["statusContent"])}
                              </TableCell>
                              <TableCell
                                size="small"
                                sx={{ pt: 1.5, pb: 1.5, fontSize: "12px" }}
                                key={"details"}
                              >
                                <Link
                                  to="/query-chat-thread"
                                  state={{
                                    queryRecord: row,
                                  }}
                                >
                                  <Box sx={{ display: "flex" }}>
                                    Details <ArrowForwardIcon />
                                  </Box>
                                </Link>
                              </TableCell>
                            </TableRow>
                          );
                        })}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  rowsPerPageOptions={[10, 25, 100]}
                  component="div"
                  count={
                    isSearchMode ? searchedRows?.length ?? 0 : totalNoOfRecords
                  }
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Paper>
            ) : (
              <Paper>
                <NoDataComponent />
              </Paper>
            )}
          </Grid>
        </Grid>
      </Container>
    </>
  );
};
export default QueryList;
